import React from 'react';
import PropTypes from 'prop-types';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import ConversionStatusCellRenderer from './ConversionStatusCellRenderer';
import ToggleSwitchCellRenderer from './ToggleSwitchCellRenderer';

export const ConversionStateCellRenderer = ({ data, ...rest }) => {
    const selectedAccountData = useAccount();
    return (
        <ConversionStatusCellRenderer
            data={{
                ...data,
                selectedAccountData,
            }}
            {...rest}
            defaultMessage="Conversion Status"
        />
    );
};
ConversionStateCellRenderer.propTypes = {
    ...ToggleSwitchCellRenderer.propTypes,
    isDisabled: PropTypes.func,
};

ConversionStateCellRenderer.defaultProps = {
    isDisabled: () => false,
};
